import { render } from "./DialogRecieveError.vue?vue&type=template&id=e17f419a"
import script from "./DialogRecieveError.vue?vue&type=script&lang=js"
export * from "./DialogRecieveError.vue?vue&type=script&lang=js"
script.render = render

export default script